import { IntegrationServiceId } from '../../../../common/integrations'
import { ClickNavigationProps } from '../../../../components/NavigationWithSideBar/ClickNavigation'
import { AdvisorEngineSpecificSettings } from './AdvisorEngine/AdvisorEngineSpecificSettings'
import { DynamicsBasedSpecificSettings } from './DynamicsBased/DynamicsBasedSpecificSettings'
import { EMoneySpecificSettings } from './eMoney/EMoneySpecificSettings'
import { HubSpotSpecificSettings } from './Hubspot/HubspotSpecificSettings'
import { OrionSpecificSettings } from './Orion/OrionSpecificSettings'
import { PhoneSpecificSettings } from './Phone/PhoneSpecificSettings'
import { PreciseFPSpecificSettings } from './PreciseFP/PreciseFPSpecificSettings'
import { RedtailSpecificSettings } from './Redtail/RedtailSpecificSettings'
import { RightCapitalSpecificSettings } from './RightCapital/RightCapitalSpecificSettings'
import { SalesforceBasedSpecificSettings } from './SalesforceBased/SalesforceBasedSpecificSettings'
import { SmartOfficeSpecificSettings } from './SmartOffice/SmartOfficeSpecificSettings'
import { WealthboxSpecificSettings } from './Wealthbox/WealthboxSpecificSettings'
import { ZohoSpecificSettings } from './Zoho/ZohoSpecificSettings'
import { ZoomSpecificSettings } from './Zoom/ZoomSpecificSettings'

export interface IntegrationSpecificSettingProps {
  serviceId: IntegrationServiceId
}

export const IntegrationSpecificSetting = ({ serviceId }: IntegrationSpecificSettingProps): ClickNavigationProps[] => {
  switch (serviceId) {
    case IntegrationServiceId.SALESFORCE:
    case IntegrationServiceId.PRACTIFI:
    case IntegrationServiceId.XLR8:
    case IntegrationServiceId.BLACK_DIAMOND:
    case IntegrationServiceId.ELEMENTS:
      return SalesforceBasedSpecificSettings(serviceId)
    case IntegrationServiceId.WEALTHBOX:
      return WealthboxSpecificSettings()
    case IntegrationServiceId.REDTAIL:
      return RedtailSpecificSettings()
    case IntegrationServiceId.HUBSPOT:
      return HubSpotSpecificSettings()
    case IntegrationServiceId.ZOHO:
      return ZohoSpecificSettings()
    case IntegrationServiceId.DYNAMICS:
    case IntegrationServiceId.ENGAGE:
      return DynamicsBasedSpecificSettings(serviceId)
    case IntegrationServiceId.SMARTOFFICE:
      return SmartOfficeSpecificSettings()
    case IntegrationServiceId.ADVISOR_ENGINE:
      return AdvisorEngineSpecificSettings()
    case IntegrationServiceId.PRECISE_FP:
      return PreciseFPSpecificSettings()
    case IntegrationServiceId.ORION:
      return OrionSpecificSettings()
    case IntegrationServiceId.E_MONEY:
      return EMoneySpecificSettings()
    case IntegrationServiceId.RIGHT_CAPITAL:
      return RightCapitalSpecificSettings()
    case IntegrationServiceId.ZOOM:
      return ZoomSpecificSettings()
    case IntegrationServiceId.PHONE:
      return PhoneSpecificSettings()
    default:
      return []
  }
}
